import { useAuth } from '@/core/auth/useAuth';
import { useActiveContext } from '@/shared/hooks/useActiveContext';
import {
  canManageTreasury,
  canManageTreasuryBanking,
  canManageTreasuryReconciliation,
  canViewTreasury,
} from '@/modules/treasury/utils/permissions';

type ScopeType = 'company' | 'location';

interface UseTreasuryPermissionsOptions {
  scopeType?: ScopeType;
  locationId?: string | null;
}

export function useTreasuryPermissions(options: UseTreasuryPermissionsOptions = {}) {
  const { user } = useAuth();
  const { activeContext, activeLocationId } = useActiveContext();

  const scopeType = options.scopeType ?? (activeContext?.type === 'company' ? 'company' : 'location');
  const locationId = options.locationId ?? (scopeType === 'location' ? activeLocationId : null);

  return {
    scopeType,
    locationId,
    canViewTreasury: canViewTreasury(user, scopeType, locationId),
    canManageTreasury: canManageTreasury(user, scopeType, locationId),
    canManageTreasuryBanking: canManageTreasuryBanking(user, scopeType, locationId),
    canManageTreasuryReconciliation: canManageTreasuryReconciliation(user, scopeType, locationId),
  };
}
